var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEventOperation(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 38 39",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#event-operation_svg__clip0_1036_58852)",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19 36.712v-14.25a3.393 3.393 0 013.393-3.393v0a3.393 3.393 0 013.393 3.393v7.464h5.428a5.429 5.429 0 015.429 5.429v1.357",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.714 4.14a1.357 1.357 0 100-2.714 1.357 1.357 0 000 2.714zM13.571 4.14a1.357 1.357 0 100-2.714 1.357 1.357 0 000 2.714zM24.429 4.14a1.357 1.357 0 100-2.714 1.357 1.357 0 000 2.714zM2.714 13.64a1.357 1.357 0 100-2.714 1.357 1.357 0 000 2.714zM13.571 13.64a1.357 1.357 0 100-2.714 1.357 1.357 0 000 2.714zM24.429 13.64a1.357 1.357 0 100-2.714 1.357 1.357 0 000 2.714zM2.714 23.14a1.357 1.357 0 100-2.714 1.357 1.357 0 000 2.714zM13.571 23.14a1.357 1.357 0 110-2.714v2.714z",
    fill: "#fff",
    strokeWidth: 1.5
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "event-operation_svg__clip0_1036_58852"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    transform: "translate(0 .069)",
    d: "M0 0h38v38H0z"
  })))));
}
export default SvgEventOperation;